const objToArr = obj => Object.values(obj);

export default objToArr;
